import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { TenantHeaderName } from 'features/tenants/Constants';
import { getCurrentTenantId } from '~/features/tenants/helpers/TenantHelper';

/**
 * Helper that creates and configures an instance of Axios to be used throughout
 * the client application. This will also handle forbidden (403) errors via interceptors.
 */
const AxiosHelper: AxiosInstance = axios.create({
	withCredentials: true,
});

export default AxiosHelper;

export type CustomAxiosRequestConfig = AxiosRequestConfig & {
	redirectToAccessDeniedOn403?: boolean;
};

export const addAccessDeniedInterceptor = (history) => {
	// this allows us to act when any request going through axios succeeds or fails.
	AxiosHelper.interceptors.response.use(
		(response: AxiosResponse) => {
			return response;
		},
		(error: AxiosError) => {
			const config: CustomAxiosRequestConfig = error.config;

			// if the request is meant to send you to an access-denied page, then replace the
			// history entry. this will be called primarily from listing pages.
			if (config && config.redirectToAccessDeniedOn403 && error.response && error.response.status === 403) {
				history.replace('/access-denied');
			}

			if (error.response && error.response.status === 401) {
				window.location.replace('/login');
			}

			return Promise.reject(error);
		},
	);
};

// Add tenant header ('X-Roc-Tenant') with tenant id value from the session storage to every request.
export const addMultiTenantInterceptor = () => {
	AxiosHelper.interceptors.request.use(
		(config) => {
			config.headers[TenantHeaderName] = getCurrentTenantId();

			return config;
		},
		(error) => {
			return Promise.reject(error);
		},
	);
};
